import React from 'react'
import { priceLine } from '../content'
import LineIcon from '../icons'
import { fillOffer } from '../offer'
import { Checks, Pill, Pills, PriceRow } from '../styled'

/**
 * The price, the offer pills and the three checks, as the hero and the offer card show them.
 *
 * @param offer   the visitor's prices; the lines that need them wait until they load
 * @param column  the checks stacked, as on the offer card
 */
const PriceBlock = ({ offer, column = false }) => (
  <>
    {offer.price && (
      <PriceRow>
        <b>{offer.price}</b>
        {/* Retired 14 October 2026: the list price next to the offer; restore with priceLine.msrpLabel
        {offer.msrp && (
          <span>
            {priceLine.msrpLabel} {offer.msrp}
          </span>
        )} */}
      </PriceRow>
    )}
    <Pills>
      <Pill $offer>{priceLine.limited}</Pill>
      <Pill>{priceLine.guarantee}</Pill>
    </Pills>
    <Checks $column={column}>
      {priceLine.checks.map((item) => {
        const filled = fillOffer(item, offer)
        return (
          filled && (
            <li key={item}>
              <LineIcon name="check" />
              {filled}
            </li>
          )
        )
      })}
    </Checks>
  </>
)

export default PriceBlock
